import { render } from "./about.vue?vue&type=template&id=788872c8&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=788872c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kenyo\\Documents\\dev\\passwords\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788872c8"]])

export default __exports__